import React from 'react';
import '../less/index.less';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.less';
import { ReactSVG } from 'react-svg';
import SegmentedStorybook from '@abank/abank-segmented';
import proposal_arrow from '../img/proposal_arrow.svg';

export default function template() {
  const { tabs, activeTab, title, subtitle, swiperRef, items, isSegmentedCollapsed, leadIcon, renderSlide, className, slidesPerView, groupSize = 1, spaceBetween, controlsBelowOnMobile, btnText, btnLink, btnId, defaultSliderItemTitleTag } = this.props;

  const SliderItemTitleTag = defaultSliderItemTitleTag || 'h3';

  const showControls = !(this.state.proposalAtStart && this.state.proposalAtEnd);

  const showTopControls = showControls && !(controlsBelowOnMobile && this.state.isMobile);

  const showBottomControls = showControls && controlsBelowOnMobile && this.state.isMobile;

  const renderControls = () => (
    <div className="top-more-slider__controls">
      <button
        onClick={this.slidePrev}
        disabled={this.state.proposalAtStart}
        className={`top-more-slider__btn top-more-slider__btn_left ${
          this.state.proposalAtStart ? 'top-more-slider__btn_disabled' : ''
        }`}
      >
        <ReactSVG
          src={proposal_arrow}
          className="top-more-slider__arrow top-more-slider__arrow_left"
        />
      </button>

      <button
        onClick={this.slideNext}
        disabled={this.state.proposalAtEnd}
        className={`top-more-slider__btn top-more-slider__btn_right ${
          this.state.proposalAtEnd ? 'top-more-slider__btn_disabled' : ''
        }`}
      >
        <ReactSVG
          src={proposal_arrow}
          className="top-more-slider__arrow top-more-slider__arrow_right"
        />
      </button>
    </div>
  );

  const renderTop = () => (
    <div className="more-slider__top top-more-slider">
      <div className="container">
        <div className="top-more-slider__row">
          {tabs ? (
            <SegmentedStorybook
              collapsed={isSegmentedCollapsed}
              tabs={tabs}
              tab={activeTab}
              toggle={this.toggleTab}
              leadIcon={leadIcon}
            />
          ) : (
            <h2 className="top-more-slider__title">{this.l10n(title)}</h2>
          )}
          {showTopControls && renderControls()}
        </div>
        {subtitle && <div className="top-more-slider__subtitle">{this.l10n(subtitle)}</div>}
      </div>
    </div>
  )

  const defaultRenderSlide = (item) => (
    <a
      className="item-more-slider__link"
      href={item.link}
      onClick={e => item.target === "_blank" ? undefined : this.navigate(item.link, e)}
      id={item.id}
      target="_self"
    >
      <div className="item-more-slider__image">
        <img src={item.img} alt={this.l10n(item.title)} />
      </div>
      <div className="item-more-slider__content">
        <SliderItemTitleTag className="item-more-slider__title">
          {this.l10n(item.title)}
        </SliderItemTitleTag>
        <div className="item-more-slider__text">
          {this.l10n(item.text)}
        </div>
      </div>
    </a>
  );

  const slides = activeTab !== undefined && activeTab !== null ? items[activeTab] : items;

  const chunkItems = (array, size) => {
    if (size <= 1) return array.map(item => [item]);

    const result = [];
    for (let i = 0; i < array.length; i += size) {
      result.push(array.slice(i, i + size));
    }
    return result;
  };

  const groupedSlides = chunkItems(slides, groupSize);

  return (
    <div className={`more-slider ${className ? className : 'default-slider'}`}>
      {renderTop()}
      <div className="more-slider__body">
        <Swiper
          ref={swiperRef}
          slidesPerView={slidesPerView ? slidesPerView : "auto"}
          spaceBetween={spaceBetween ? spaceBetween : this.state.isMobile ? 16 : 24}
          autoHeight={false}
          onSwiper={swiper => {
            swiperRef.current.swiper = swiper;
            this.swiperCleanup = this.syncProposalSwiperState();
          }}
          threshold={10}
        >
          {groupedSlides.map((group, index) => {
            const firstItem = group[0];

            return (
              <SwiperSlide
                key={firstItem.id || index}
                className={`more-slider__item item-more-slider item-more-slider_${index + 1}`}
              >
                {groupSize > 1 ? (
                  <div className="more-slider__items">
                    {group.map((item, index) =>
                      (renderSlide || defaultRenderSlide)(item, index)
                    )}
                  </div>
                ) : (
                  (renderSlide || defaultRenderSlide)(firstItem, index)
                )}
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>
      {showBottomControls && (
        <div className="more-slider__bottom">
          {renderControls()}
        </div>
      )}
      {(btnText && btnLink) && (
        <div className="more-slider__btn-wrapper">
          <div className="container">
            <a className="more-slider__btn" href={btnLink} onClick={e => this.navigate(btnLink, e)} id={btnId}>{this.l10n(btnText)}</a>
          </div>
        </div>
      )}
    </div>
  );
}
